import Main from './main.vue';

let instance;
let instances = [];
let seed = -1;
let ToastConstructor = Vue.extend(Main);

const Toast = function (options) {
    options = options || {};
    if (typeof options === 'string') {
        options = {
            message: options
        };
    }
    instance = new ToastConstructor({
        data: options
    });
    seed++
    instance.visible = true;
    instance.$mount();
    document.body.appendChild(instance.$el);
    instances.push(instance);
    instances.forEach((item, index) => {
        if (seed === index) {
            item.visible = true
        } else {
            item.visible = false
        }
    })
    return instance;
};



['loading', 'success', 'fail', 'html'].forEach(type => {
    Toast[type] = options => {
        if (typeof options === 'string') {
            options = {
                message: options
            };
        }
        options.type = type;
        return Toast(options);
    };
});


export default Toast;